// src/components/Popups/HomeWidgetGalleryPopup.jsx
//
// „Adaugă un widget” pe pagina principală a elevului (modul „Editează”):
// widget-urile care nu sunt pe ecran, fiecare cu o previzualizare adevărată
// (desenată cu datele elevului, micșorată) în mărimea aleasă. Alegi mărimea,
// vezi cum arată, apoi „Adaugă” îl pune la sfârșitul grilei.

import React, { useState } from "react";

import { closePopup } from "../Common/popupUIStore";
import { SIZES } from "../SPanel/Home/homeLayout";

// latura unei celule în previzualizare (ca pe un telefon) și spațiul dintre ele
const PREVIEW_CELL = 150;
const PREVIEW_GAP = 8;

function SizeShape({ size }) {
   const { w, h } = SIZES[size];
   return (
      <span className="widgetGallery__shape" aria-hidden="true">
         {Array.from({ length: 4 }, (_, i) => {
            const col = i % 2;
            const row = Math.floor(i / 2);
            return <i key={i} className={col < w && row < h ? "is-on" : ""} />;
         })}
      </span>
   );
}

function Preview({ widget, size, renderPreview }) {
   const { w, h } = SIZES[size];
   const width = w * PREVIEW_CELL + (w - 1) * PREVIEW_GAP;
   const height = h * PREVIEW_CELL + (h - 1) * PREVIEW_GAP;
   return (
      <div className="widgetGallery__preview shome" aria-hidden="true">
         <div className={`hw hw--${size}`} style={{ width, height }}>
            <div className="hw__jiggle">{renderPreview?.(widget.id, size)}</div>
         </div>
      </div>
   );
}

function GalleryItem({ widget, renderPreview, onAdd }) {
   const [size, setSize] = useState(widget.sizes[0]);
   return (
      <div className="appearancePopup__row appearancePopup__row--stack widgetGallery__item">
         <div className="appearancePopup__label">
            <span>{widget.title}</span>
            <small>{widget.description}</small>
         </div>

         <Preview widget={widget} size={size} renderPreview={renderPreview} />

         <div className="widgetGallery__controls">
            {widget.sizes.length > 1 && (
               <div className="widgetGallery__sizes" role="radiogroup" aria-label="Mărimea">
                  {widget.sizes.map((option) => (
                     <button
                        key={option}
                        type="button"
                        role="radio"
                        aria-checked={size === option}
                        className={"widgetGallery__size" + (size === option ? " is-active" : "")}
                        onClick={() => setSize(option)}
                        title={`${SIZES[option].label} · ${option.replace("x", "×")}`}
                     >
                        <SizeShape size={option} />
                        <span>{SIZES[option].label}</span>
                     </button>
                  ))}
               </div>
            )}
            <button
               type="button"
               className="widgetGallery__add"
               onClick={() => {
                  onAdd?.(widget.id, size);
                  closePopup();
               }}
            >
               Adaugă
            </button>
         </div>
      </div>
   );
}

export default function HomeWidgetGalleryPopup({ available = [], onAdd, renderPreview }) {
   return (
      <div className="appearancePopup widgetGallery">
         <div className="appearancePopup__header">
            <h3 className="appearancePopup__title">Adaugă un widget</h3>
            <p className="appearancePopup__lead">
               Alege mărimea, vezi cum arată, apoi adaugă-l. Îl poți muta oriunde pe pagină.
            </p>
         </div>

         <div className="appearancePopup__content">
            {available.length === 0 ? (
               <p className="widgetGallery__empty">Toate widget-urile sunt deja pe pagină.</p>
            ) : (
               <div className="appearancePopup__list">
                  {available.map((widget) => (
                     <GalleryItem
                        key={widget.id}
                        widget={widget}
                        renderPreview={renderPreview}
                        onAdd={onAdd}
                     />
                  ))}
               </div>
            )}
         </div>
      </div>
   );
}
